import { render, staticRenderFns } from "./RelatedItem.vue?vue&type=template&id=046acf54&scoped=true&"
import script from "./RelatedItem.vue?vue&type=script&lang=js&"
export * from "./RelatedItem.vue?vue&type=script&lang=js&"
import style0 from "./RelatedItem.vue?vue&type=style&index=0&id=046acf54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046acf54",
  null
  
)

export default component.exports